// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

// Reserved option id used when includeNotSet is true. The user's customer
// keys use nano-id prefixes (cus_…) and UUIDs never collide with this
// literal, so callers can detect the sentinel in their value / onChange
// payloads and translate it to whatever null-customer representation the
// backend expects.
export const NOT_SET_SENTINEL = 'NONE';
